import React from 'react';
import { ArrowDown, ArrowUp, Plus, X } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

const LINKS = [
  ['none', 'Sin enlace'], ['/client-portal/briefing', 'Briefing'], ['/client-portal/documents', 'Documentos'],
  ['/client-portal/approvals', 'Aprobaciones'], ['/client-portal/calendar', 'Calendario'], ['/client-portal/invoices', 'Facturas'],
  ['/client-portal/reports', 'Informes'], ['/client-portal/campaigns', 'Campañas'],
];

export const WelcomeStepsEditor = ({ pasos, onChange }) => {
  const set = (i, patch) => onChange(pasos.map((p, j) => (j === i ? { ...p, ...patch } : p)));
  const move = (i, d) => { const ps = [...pasos]; [ps[i], ps[i + d]] = [ps[i + d], ps[i]]; onChange(ps); };
  return (
    <div className="space-y-2" data-testid="welcome-steps-editor">
      {pasos.map((p, i) => (
        <div key={p.id} className="rounded-lg border p-3 space-y-2" data-testid={`ws-step-${i}`}>
          <div className="flex items-center gap-1.5">
            <Input value={p.titulo} onChange={(e) => set(i, { titulo: e.target.value })} className="font-medium" placeholder="Paso" data-testid={`ws-step-${i}-title`} />
            <Button variant="ghost" size="icon" disabled={i === 0} onClick={() => move(i, -1)}><ArrowUp className="w-4 h-4" /></Button>
            <Button variant="ghost" size="icon" disabled={i === pasos.length - 1} onClick={() => move(i, 1)}><ArrowDown className="w-4 h-4" /></Button>
            <Button variant="ghost" size="icon" onClick={() => onChange(pasos.filter((_, j) => j !== i))} data-testid={`ws-step-${i}-delete`}><X className="w-4 h-4" /></Button>
          </div>
          <div className="flex gap-2">
            <Textarea value={p.descripcion} onChange={(e) => set(i, { descripcion: e.target.value })} placeholder="Explicación" rows={4} data-testid={`ws-step-${i}-desc`} />
            <Select value={p.enlace || 'none'} onValueChange={(v) => set(i, { enlace: v === 'none' ? '' : v })}>
              <SelectTrigger className="w-[160px]" data-testid={`ws-step-${i}-link`}><SelectValue /></SelectTrigger>
              <SelectContent>{LINKS.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}</SelectContent>
            </Select>
          </div>
        </div>
      ))}
      <Button variant="outline" size="sm" onClick={() => onChange([...pasos, { id: crypto.randomUUID(), titulo: 'Nuevo paso', descripcion: '', enlace: '' }])} data-testid="ws-add-step-btn">
        <Plus className="w-4 h-4 mr-1" />Añadir paso
      </Button>
    </div>
  );
};
